/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ConversionFunnelIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Conversion Funnel',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M10 24v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V24Zm11.975 4.2-5.053 6.738a.375.375 0 0 1-.565.04L12.7 31.326a.375.375 0 0 1 0-.53l1.6-1.596a.375.375 0 0 1 .53 0l1.512 1.512 3.233-4.312a.375.375 0 0 1 .525-.075l1.8 1.35a.375.375 0 0 1 .075.525ZM29 12H5l4.167 10h15.666L29 12zM33.25 0H.75a.5.5 0 0 0-.462.692L4.167 10h25.666L33.712.692A.5.5 0 0 0 33.25 0Z"
    />
  </svg>`;
};
